import { useProductCatalogContext } from "@/context/ProductCatalogContext";
import { ProductSearchBar } from "./ProductSearchBar";
import { ProductGrid } from "./ProductGrid";

export const ShopProducts = () => {
  const { error } = useProductCatalogContext();

  if (error) {
    throw error;
  }

  return (
    <div data-cypress="shop-products-page">
      <ProductSearchBar />
      <ProductGrid />
    </div>
  );
};
